export const headerSection = {
	fontWeight: '600',
	// fontSize: '20px',
};
export const headerStyling = {
	display: 'flex',
	gap: '1rem',
	alignItems: 'center',
	// padding: '0.5rem',
	// marginBottom: '1rem',
	backgroundColor: '#2081B8',
	color: 'white',
};
export const textStyling = {
	// fontSize: '20px',
	color: '#B8B1B1',
	textAlign: 'center',
};
export const borderColor = {
	borderLeft: '6px solid #D98543',
	borderTopLeftRadius: '0.4rem',
	borderBottomLeftRadius: '0.4rem',
};
export const titleWithTextfield = {
	display: 'flex',
	flexDirection: 'column',
	gap: '0.2rem',
};
export const csvStyle = {
	width: '40.77px',
	height: '37.86px',
	cursor: 'pointer',
};
export const pdfStyle = {
	width: '32.3px',
	height: '37.68px',
	cursor: 'pointer',
};
export const grid_Button_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	gap: '1.5rem',
	alignItems: 'end',
};
export const grid_Icon_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'end',
};
export const button_Styles1 = {
	padding: '0.5rem 1.5rem',
	backgroundColor: '#FD7702',
	textTransform: 'capitalize',
	letterSpacing: '0.1rem',
};

export const button_Styles2 = {
	padding: '0.5rem 1.5rem',
	backgroundColor: '#ED2828',
	textTransform: 'capitalize',
	letterSpacing: '0.1rem',
};

export const buttonStyles = {
	display: 'flex',
	justifyContent: 'center',
	gap: '1rem',
	marginLeft: '2rem',
};
export const icon_Grid_Style = {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'end',
};
export const filterSectionStyle = {
	// height: '55vh',
	alignItems: 'center',
	display: 'flex',
};
export const bookIconStyle = {
	position: 'relative',
	justifyContent: 'center',
	display: 'flex',
	top: '-30px',
};
export const bookIconPaperStyle = {
	width: '66px',
	height: '62px',
	borderRadius: '8px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backgroundColor: '#00C7F7',
	cursor: 'pointer',
};
export const paperStyle = {
	padding: '0.5rem',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	cursor: 'pointer',
};
export const titleStyle = {
	color: '#BC1111',
	fontWeight: 'bold',
	padding: '1rem',
	fontSize: '20px',
	marginBottom: '1rem',
};
